const carousel = {
  carouselIdendity: 'Centralisez toute votre identité digitale sur un profil',
  carouselClickTree: 'Plus que des clics, des arbres plantés',
  carouselReward: 'Transformez vos récompenses en offres exclusives',
}

export default carousel
